export const LOAD_CAMPAIGN_STEP_COMPLETION = 'load_campaign_step_completion'; 
export const LOAD_CAMPAIGN_STEP_COMPLETION_ERROR = 'load_campaign_step_completion_error'; 

export enum CampaignStepCompletionType {
    EXECUTION = 'execution',
    PREPARATION = 'preparation',
    INTEGRATION = 'integration' 
}